import { simpleSet } from '@r/reducers/utils';

const setCalculationModeToeKickType = simpleSet as
  redux.reducers.calculationMode.projects.currentProject.settings.dimensions.toeKickType;

export const toeKickType = setCalculationModeToeKickType(
  'SET_CALCULATION_MODE_CURRENT_PROJECT_TOE_KICK_TYPE',
  'toFloor'
);
